// ROLES
export const ROLE_ACCOUNT_MGR_BILLING = 'coadmin'
export const ROLE_ACCOUNT_MGR = 'coadminnp'
export const ROLE_ATTR_ADMIN = 'admin'
export const ROLE_USER = 'user';
export const ROLE_USER_BASIC = 'user basic';
export const ROLE_SUPER_ADMIN = 'superadmin'
export const ROLE_SITE_ADMIN = 'siteadmin'
export const ROLE_PROJECT_MGR = 'projman'
export const ROLE_FINANCE = 'finance'
export const ROLE_PROJECT_VIEW = 'projview'

export const TYPE_COMMENT = 'comment';
export const TYPE_FILE = 'file';
export const TYPE_ORDER = 'order';
export const TYPE_OTHER = 'other';
